module.exports = __webpack_public_path__ + "static/media/IMG-3176.02aa4f88.jpg";